import { VNode } from "vue";
import { DirectiveBinding } from "vue/types/options";

interface DirectiveHTMLElement extends HTMLElement {
  clickOutsideEvent: (event: Event) => void;
}

const clickoutside = {
  bind: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
    if (typeof binding.value !== "function") {
      const componentName = vnode.context?.$options.parent?.$options.name;
      const warning = `[Vue-click-outside]: provided expression '${
        binding.expression
      }' is not a function ${componentName ? `found in ${componentName}` : ""}`;

      console.warn(warning);
    }
    const handler = (event: Event) => {
      if (
        event.target instanceof HTMLElement &&
        !(el === event.target || el.contains(event.target))
      ) {
        binding.value(event);
      }
    };
    (el as DirectiveHTMLElement).clickOutsideEvent = handler;
    document.addEventListener(
      "click",
      (el as DirectiveHTMLElement).clickOutsideEvent
    );
  },
  unbind: (el: HTMLElement) => {
    document.removeEventListener(
      "click",
      (el as DirectiveHTMLElement).clickOutsideEvent
    );
  }
};

export { clickoutside };
